import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { useJumpLink } from '../../../../hooks';
import PricingCard from '../TutoringPricingCard';
import { Wrapper, StyledContainer } from '../../Shared/PricingSection/styles';

import { TutoringCards, TutoringCTALink, TutoringCTAContainer } from './styles';

const TutoringPricingSection = ({ data }) => {
  if (!data) {
    return null;
  }

  const {
    titleHtml,
    subTitleHtml,
    items,
    cta,
    ctaText,
    queryStringCTA,
    ariaLabelCTA,
    imageBackground,
    imageMobileBackground,
    imageBackgroundSharp,
    imageMobileBackgroundSharp,
  } = data;

  useJumpLink();

  const hasCTAContent = cta && typeof ctaText === 'string';
  return (
    <Wrapper id="pricing-details">
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(titleHtml)}
        {ReactHtmlParser(subTitleHtml)}
        {hasCTAContent && (
          <TutoringCTAContainer>
            <TutoringCTALink
              to={cta.url}
              className="solid-on-light-bg"
              queryString={queryStringCTA}
              ariaLabel={ariaLabelCTA}
            >
              {ctaText}
            </TutoringCTALink>
          </TutoringCTAContainer>
        )}
        <TutoringCards
          spacing="10px"
          columns={3}
          background={imageBackground ? imageBackgroundSharp.publicURL : null}
          mobileBackground={
            imageMobileBackground
              ? imageMobileBackgroundSharp.publicURL
              : imageBackground.url
          }
        >
          {items.map((item, index) => {
            return (
              <PricingCard
                data={item}
                key={`pricing-card-${index.toString()}`}
              />
            );
          })}
        </TutoringCards>
      </StyledContainer>
    </Wrapper>
  );
};

TutoringPricingSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

TutoringPricingSection.defaultProps = {};

export default TutoringPricingSection;
